<script setup>
import config from '@/config'
const VERSION = config.VITE_VERSION || 'v1.0.24'
</script>
<template>
  <div class="container-lg pt-3 bg_body">
    <main class="main">
      <div class="main_login">
        <div class="table-rtms login_table">
          <div class="login_head">
            <img
              src="@/assets/logo_black.svg"
              alt="logo"
              class="logo_login"
            />
          </div>

          <slot />
          <div class="footer">
            <p class="m-0">
              SOYKA:RTMS {{ VERSION }}<br />
              Developed by
              <a
                href="//atd.systems"
                target="_blank"
                class="fs-14 link-danger"
                >ATD.Systems</a
              >
            </p>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>
